module.exports = __webpack_public_path__ + "img/Mode_Selector_KingRoyal.2523ee3d.png";